import { MessageWithActionAndData } from "@me8eon/sessions_messages";
import React from "react";
import { UserMessageComponent } from "../organisms/MessageItem/UserMessageComponent";
import { AssistantMessageComponent } from "../organisms/MessageItem/AssistantMessageComponent";
import { ToolMessageComponent } from "../organisms/MessageItem/ToolMessageComponent";

type MessageByRoleRecord = {
    [key in MessageWithActionAndData['role']]: React.FC<{
    message: MessageWithActionAndData
    isLast: boolean
    isStreaming?: boolean
}> | null
}

const MessageByRole: MessageByRoleRecord = {
    user: UserMessageComponent,
    assistant: AssistantMessageComponent,
    tool: ToolMessageComponent,
    system: null
};

export const useMapMessagesToComponentsHook = (messages: MessageWithActionAndData[]) => {
    return messages.map((m, i) => {
        const MessageComponent = MessageByRole[m.role];
        if (!MessageComponent) return null;

        const isStreaming = Boolean((m.data as any)?.streaming);

        return (
            <MessageComponent
                key={`message_${i}`}
                message={m}
                isLast={i === messages.length - 1}
                isStreaming={isStreaming}
            />
        );
    }).filter(Boolean);
};